<template>
	<div
		class="selectable"
		:class="{ selected: selected }">

		<slot></slot>
	</div>
</template>

<script>
	export default {
	    data() {
	        return {
	            selected: false
	        }
	    },
	    methods: {
			select () {
				this.selected = true
			},
			deselect () {
				this.selected = false
			}
	    }
	}
</script>

<style lang="scss" scoped>
	.selectable {
		width: 40px;
		height: 40px;
		background:#efefef;
		margin: 8px;

		// testing
		position: absolute;
		width: rem-calc(100);
		height: rem-calc(100);
	}

	.selectable.selected {
		border: 1px solid blue;
	}
</style>